// src/components/public/ProjectCard.js
import { useState } from "react";

// microlink.io — ücretsiz, key gerekmez, CORS yok
const screenshotUrl = (url, waitMs = 2000) =>
  `https://api.microlink.io/?url=${encodeURIComponent(url)}&screenshot=true&meta=false&embed=screenshot.url&waitForTimeout=${waitMs}`;

export default function ProjectCard({ proj, index, getLang, settings }) {
  const [imgStatus, setImgStatus] = useState("loading"); // loading | loaded | error
  const [hovered, setHovered] = useState(false);

  const displayUrl = proj.url?.replace(/^https?:\/\//, "").replace(/\/$/, "");

  return (
    <a
      href={proj.url}
      target="_blank"
      rel="noreferrer"
      style={{
        display: "block", textDecoration: "none", position: "relative", overflow: "hidden",
        background: "var(--card)", border: "1px solid var(--border)", borderRadius: "var(--radius)",
        backdropFilter: "blur(8px)",
        transition: "transform 0.3s, border-color 0.3s, box-shadow 0.3s",
        transform: hovered ? "translateY(-4px)" : "none",
        borderColor: hovered ? "var(--border-strong)" : "var(--border)",
        boxShadow: hovered ? "0 16px 32px -16px rgba(124,108,255,0.35)" : "none",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Screenshot area */}
      <div style={{ position: "relative", paddingTop: "56.25%", background: "#0d0d16", overflow: "hidden" }}>

        {/* Skeleton shimmer while loading */}
        {imgStatus === "loading" && (
          <div style={{ position: "absolute", inset: 0, background: "linear-gradient(90deg,#0d0d16 25%,#181828 50%,#0d0d16 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.5s infinite" }} />
        )}

        {/* Actual screenshot */}
        {proj.url && (
          <img
            src={screenshotUrl(proj.url, settings?.screenshot_wait ?? 2000)}
            alt={getLang(proj, "name")}
            onLoad={() => setImgStatus("loaded")}
            onError={() => setImgStatus("error")}
            style={{
              position: "absolute", inset: 0, width: "100%", height: "100%",
              objectFit: "cover", objectPosition: "top",
              opacity: imgStatus === "loaded" ? 1 : 0,
              transition: "opacity 0.4s, transform 0.4s",
              transform: hovered ? "scale(1.04)" : "scale(1)",
            }}
          />
        )}

        {/* Fallback when screenshot unavailable */}
        {imgStatus === "error" && (
          <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8 }}>
            <div style={{ fontSize: 28, color: "var(--accent)", opacity: 0.4 }}>◈</div>
            <div style={{ fontSize: 10, color: "var(--muted)", letterSpacing: "0.1em" }}>{displayUrl}</div>
          </div>
        )}

        {/* Hover overlay */}
        <div style={{ position: "absolute", inset: 0, background: "rgba(8,8,13,0.72)", backdropFilter: "blur(2px)", opacity: hovered ? 1 : 0, transition: "opacity 0.3s", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 600, fontSize: 13, color: "#0a0a12", background: "var(--gradient)", borderRadius: 999, padding: "10px 22px", boxShadow: "0 8px 24px -8px rgba(124,108,255,0.6)" }}>
            Siteyi Ziyaret Et ↗
          </span>
        </div>

        {/* Tag badge */}
        {proj.tag && (
          <div style={{ position: "absolute", top: 12, left: 12, background: "rgba(8,8,13,0.7)", backdropFilter: "blur(6px)", border: "1px solid var(--border-strong)", color: "var(--text)", fontSize: 10, fontFamily: "'Space Grotesk',sans-serif", fontWeight: 600, letterSpacing: "0.05em", padding: "4px 12px", borderRadius: 999 }}>
            {proj.tag}
          </div>
        )}
      </div>

      {/* Card footer */}
      <div style={{ padding: "18px 20px", borderTop: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 600, fontSize: 14, color: "var(--text)", marginBottom: 3, lineHeight: 1.3 }}>
            {getLang(proj, "name")}
          </div>
          <div style={{ fontSize: 11, color: "var(--muted)" }}>{displayUrl}</div>
        </div>
        <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 11, color: "var(--muted)", flexShrink: 0, marginLeft: 12 }}>
          {String(index + 1).padStart(2, "0")}
        </div>
      </div>

      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0 }
          100% { background-position: -200% 0 }
        }
      `}</style>
    </a>
  );
}
